import { AlarmTypeModelEnum } from "@common/js/enum";
import store from "@common/js/store";
import { guid, i18nGlobal } from "@common/js/utils";
import { EnumAlarmFlag } from "@components/js/utils/model";
import DrawApi from "@core/graphs/webcharts/Dh-webchart-drawApis";
import { BandwidthPoint } from "@core/graphs/webcharts/Dh-webchart-models";
import $ from "jquery";
import { PluginBase } from "./DH-plugin-base";

export class FreqBandAlarmPlugin extends PluginBase {
    constructor() {
        super();
        this.Id = guid();
        this.drawApi = new DrawApi();
        this.datas = [];
        this.alarmInfo = null;
        this.ptArray = [];
    }
    CreatePlugin() {

    }
    OnSizeChanged() {

    }
    OnRender() {
        this.EnsureContainerCreated();
        this.drawApi.ClearAll();
        if (this.Owner.Option?.Axis.ShowAlarmLine != true) return;
        if (this.Entity.UnitCheck && this.alarmInfo && this.Owner.Information.UnitTexts.XText) {
            if (this.Owner.Information.UnitTexts.XText == "Hz" && this.alarmInfo.ParamType == 2) {
                return;
            }
            if (this.Owner.Information.UnitTexts.XText == i18nGlobal('core.order') && this.alarmInfo.ParamType < 2) {
                return;
            }
        }
        if (this.Owner.Option && this.Owner.Option.Axis.ShowAlarmLine == true) {
            const rect = this.Owner.Information.ShapeContainerRect;
            this.ptArray = this.GetPoints();
            this.drawApi.Save();
            this.drawApi.BeginPath();
            this.drawApi.ClipRect(rect.Left + 2, rect.Top, rect.Width, rect.Height);
            this.DrawRectangle(this.ptArray, this.ptArray);
            this.DrawGraphText(this.ptArray, this.ptArray);
            this.DrawDashLine(this.ptArray, this.ptArray);
            this.drawApi.Restore();
        }
    }
    SetAlarmInfo(arr) {
        this.datas = [];
        const bandWidth = arr.find((item) => item.AlarmCategory === AlarmTypeModelEnum.Bandwidth && item.IsEnabled)
        if (bandWidth) {
            this.alarmInfo = bandWidth;
            const details = JSON.parse(bandWidth.Details);
            details.forEach((item, index) => {
                item.id = index;
                const Flag = (item.Danger <= item.Warning && this.GetDangerSwitch(item) && this.GetWarningSwitch(item)) && item.AlarmType === 0 || (bandWidth.ParamType !== 1 && item.Low >= item.High)
                || (item.Danger >= item.Warning && this.GetDangerSwitch(item) && this.GetWarningSwitch(item)) && item.AlarmType === 1 || (bandWidth.ParamType !== 1 && item.Low >= item.High);
                if (!Flag) this.datas.push(item)
            });
            if (bandWidth.ParamType === 1) {
                this.datas.forEach(item => {
                    const { Low, High } = item;
                    item.Dash = item.Low;
                    item.Low = this.subtract(Low, High);
                    if (item.Low < 0) {
                        item.Low = 0;
                    };
                    item.High = this.accAdd(Low, High);
                });
            }
        }
    }
    accAdd(num1, num2) {
        let r1, r2, m;
        try { r1 = num1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = num2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        m = Math.pow(10, Math.max(r1, r2))
        return Number((num1 * m + num2 * m) / m)
    }
    subtract(num1, num2) {
        let r1, r2, m, n;
        try { r1 = num1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = num2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        m = Math.pow(10, Math.max(r1, r2));
        n = (r1 >= r2) ? r1 : r2;
        return Number(((num1 * m - num2 * m) / m).toFixed(n));
    }
    GetPoints() {
        const chart = this.Owner.Information;
        const rect = chart.ShapeContainerRect;
        const result = new Array();
        for (const d of this.datas) {
            const { AlarmType } = d;
            let rate = rect.Height / (chart.CoordinateInfo.YMax - chart.CoordinateInfo.YMin);
            let xRate = rect.Width / (chart.CoordinateInfo.XMax - chart.CoordinateInfo.XMin);
            let x1 = xRate * (d.Low - chart.CoordinateInfo.XMin);
            let x2 = xRate * (d.High - chart.CoordinateInfo.XMin);
            let xdash = xRate * d.Dash;
            if (AlarmType === 1) {
                let y2 = rate * (chart.CoordinateInfo.YMax - d.Warning);
                if (d.Warning > chart.CoordinateInfo.YMax || chart.CoordinateInfo.YMax < d.Danger) y2 = rect.Top;

                const warningHeight = this.GetDangerSwitch(d) ?  rate * (chart.CoordinateInfo.YMax - d.Danger) - y2 : rect.Top + rect.Height - 4;

                let p2 = new BandwidthPoint(rect.Left + x1, y2 + rect.Top, x2 - x1, warningHeight, "#ffae4299", "Warning", d.id);

                let normalY = y2;
                if (this.GetDangerSwitch(d) && !this.GetWarningSwitch(d)) normalY = rate * (chart.CoordinateInfo.YMax - d.Danger)
                if (this.GetWarningSwitch(d) && this.GetDangerSwitch(d)) normalY = y2

                let p3 = new BandwidthPoint(rect.Left + x1, rect.Top, x2 - x1, normalY, "#04d23b99", "normal", d.id);


                let p1 = new BandwidthPoint(rect.Left + x1, y2 + rect.Top + warningHeight, x2 - x1, rect.Top + rect.Height, "#fd404c99", "Danger", d.id, rect.Left + xdash);

                if (this.GetDangerSwitch(d)) result.push(p1);
                if (this.GetWarningSwitch(d)) result.push(p2);
                if (this.GetDangerSwitch(d) || this.GetWarningSwitch(d)) result.push(p3);
            } else {
                let y1 = rate * (chart.CoordinateInfo.YMax - d.Warning) + rect.Top;
                if (d.Warning > chart.CoordinateInfo.YMax) y1 = rect.Top;
                let p1 = new BandwidthPoint(rect.Left + x1, y1, x2 - x1, rect.Top + rect.Height - 4, "#04d23b99", "normal", d.id, rect.Left + xdash);

                let y2 = this.GetDangerSwitch(d) ? rate * (chart.CoordinateInfo.YMax - d.Danger) + rect.Top : rect.Top;
                if (d.Warning > chart.CoordinateInfo.YMax || chart.CoordinateInfo.YMax < d.Danger) y2 = rect.Top;
                let p2 = new BandwidthPoint(rect.Left + x1, y2, x2 - x1, y1 - y2, "#ffae4299", "Warning", d.id);

                let y3 = rate * 0 + rect.Top;
                const dangerY = this.GetWarningSwitch(d) ? y2 - y3 : y1 - y3;
                let p3 = new BandwidthPoint(rect.Left + x1, y3, x2 - x1, dangerY, "#fd404c99", "Danger", d.id);

                if (this.GetDangerSwitch(d)) result.push(p3);
                if (this.GetWarningSwitch(d)) result.push(p2);
                if (this.GetDangerSwitch(d) || this.GetWarningSwitch(d)) result.push(p1);

            }

        }
        return result;
    }
    GetDangerSwitch(data) {
        return data.Flag == EnumAlarmFlag.DangerOnly || data.Flag == EnumAlarmFlag.WarnAndDanger || data.DangerSwitch;
    }
    GetWarningSwitch(data) {
        return data.Flag == EnumAlarmFlag.WarnOnly || data.Flag == EnumAlarmFlag.WarnAndDanger || data.WarningSwitch;
    }
    SetBandAlarmInfo(datas) {
        this.datas = datas;
    }
    EnsureContainerCreated() {
        var container = this.Owner.PluginContainer
        var element = document.getElementById(this.Id)
        if (element == null) {
            element = document.createElement('canvas')
            element.setAttribute('id', this.Id)
            element.setAttribute('style', `position:absolute;left:0;pointer-events:none;`);
            container.before(element)
        }
        element.width = $('#' + this.Owner.ChartContainer.id).width()
        element.height = $('#' + this.Owner.ChartContainer.id).height()
        this.EnsureContainerCliped()
        return element
    }
    //确认容器已经剪裁
    EnsureContainerCliped() {
        var rect = this.Owner.Information.ShapeContainerRect
        this.drawApi.SetContext(this.Id)
        this.drawApi.ClipRect(rect.Left, rect.Top, rect.Width, rect.Height)
    }
    DrawRectangle(ptArray) {
        for (const d of ptArray) {
            this.drawApi.BeginPath();
            this.drawApi.MoveTo(d.X, d.Y);
            this.drawApi.ShadowRectangle(d.X, d.Y, d.Width, d.Height, d.color);
        }
    }
    DrawDashLine(ptArray) {
        const rect = this.Owner.Information.ShapeContainerRect;
        this.datas.forEach((item) => {
            if (item.Dash) {
                const current = ptArray.filter((t) => t.id === item.id).orderBy(p => p.Y);
                if (current.length > 0) {
                    const min = current[0].Y;
                    const X = current[0].X;
                    const dash = current.find(t => t.type === 'normal').dash;
                    this.drawApi.BeginPath();
                    this.drawApi.MoveTo(dash, min);
                    this.drawApi.LineTo(dash, rect.Height + rect.Top);
                    this.drawApi.SetLineDash([5]);
                    this.drawApi.Stroke("#fff", 2);
                }
            }
        });
    }
    DrawGraphText(ptArray) {
        const color = store.state.customColor.TextColor;
        this.datas.forEach((item) => {
            if (item.AlarmType === 1) {
                const Warning = ptArray.find((t) => t.type === "Warning" && t.id === item.id);
                const Normal = ptArray.find((t) => t.type === "normal" && t.id === item.id);
                const Danger = ptArray.find((t) => t.type === "Danger" && t.id === item.id);

                if (this.GetDangerSwitch(item) && this.GetWarningSwitch(item)) {
                    this.drawApi.FillText(item.Warning, (Warning.X + Normal.Width) + 10, Warning.Y + 5, color, "normal 10px Arial");
                    this.drawApi.FillText(item.Danger, (Danger.X + Normal.Width) + 10, Danger.Y + 5, color, "normal 10px Arial");
                }
                if (this.GetDangerSwitch(item) && !this.GetWarningSwitch(item)) {
                    this.drawApi.FillText(item.Danger, (Danger.X + Normal.Width) + 10, Danger.Y + 5, color, "normal 10px Arial");
                }
                if (!this.GetDangerSwitch(item) && this.GetWarningSwitch(item)) {
                    this.drawApi.FillText(item.Warning, (Warning.X + Normal.Width) + 10, Warning.Y + 5, color, "normal 10px Arial");
                }
            } else {
                const Warning = ptArray.find((t) => t.type === "Warning" && t.id === item.id);
                const Normal = ptArray.find((t) => t.type === "normal" && t.id === item.id);
                if (this.GetDangerSwitch(item) && this.GetWarningSwitch(item)) {
                    this.drawApi.FillText(item.Warning, (Normal.X + Normal.Width) + 10, Normal.Y + 5, color, "normal 10px Arial");
                    this.drawApi.FillText(item.Danger, (Warning.X + Normal.Width) + 10, Warning.Y + 5, color, "normal 10px Arial");
                }
                if (this.GetDangerSwitch(item) && !this.GetWarningSwitch(item)) {
                    this.drawApi.FillText(item.Danger, (Normal.X + Normal.Width) + 10, Normal.Y + 5, color, "normal 10px Arial");
                }
                if (!this.GetDangerSwitch(item) && this.GetWarningSwitch(item)) {
                    this.drawApi.FillText(item.Warning, (Normal.X + Normal.Width) + 10, Normal.Y + 5, color, "normal 10px Arial");
                }

            }

        });
    }
    Close() {
        if (this.drawApi.DrawContext) this.drawApi.Dispose();
    }
}